import { render } from "./CookieBar.vue?vue&type=template&id=6bca98fb"
import script from "./CookieBar.vue?vue&type=script&lang=js"
export * from "./CookieBar.vue?vue&type=script&lang=js"

import "./CookieBar.vue?vue&type=style&index=0&id=6bca98fb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__